<template>
  <transition name="modal-fade">
    <div v-if="visible" class="modal-mask" @click.self="handleClose">
      <div class="modal-panel" role="dialog" aria-modal="true">
        <button type="button" class="close-btn" aria-label="关闭" @click="handleClose">
          <i class="bi bi-x-lg"></i>
        </button>

        <InviteRewardPromoPanel
          :new-member-reward="newMemberReward"
          :inviter-reward="inviterReward"
        />

        <div class="action-row">
          <button v-if="!loggedIn" type="button" class="btn-primary" @click="$emit('login')">
            <i class="bi bi-wechat"></i> {{ registerCopy.actionLabel }}
          </button>
          <button v-else type="button" class="btn-primary" @click="$emit('invite')">
            <i class="bi bi-share-fill"></i> 去邀请好友，再赚 {{ inviteCopy.charLabel }}
          </button>
          <button type="button" class="btn-ghost" @click="handleClose">今日不再提示</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import InviteRewardPromoPanel from '@/components/auth/InviteRewardPromoPanel.vue'
import {
  describeInviterReward,
  describeNewMemberReward
} from '@/utils/rewardCopy'

export default {
  name: 'WorkbenchWelcomeModal',
  components: { InviteRewardPromoPanel },
  props: {
    visible: { type: Boolean, default: false },
    loggedIn: { type: Boolean, default: false },
    newMemberReward: { type: Number, default: 2000 },
    inviterReward: { type: Number, default: 1000 }
  },
  computed: {
    registerCopy() {
      return describeNewMemberReward(this.newMemberReward)
    },
    inviteCopy() {
      return describeInviterReward(this.inviterReward)
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 2400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
}

.modal-panel {
  position: relative;
  width: min(520px, 100%);
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 28px 60px rgba(79, 70, 229, 0.22);
  overflow: hidden;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.8);
  color: #6b7280;
  cursor: pointer;
}

.close-btn:hover {
  background: #fff;
  color: #111827;
}

.action-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 28px 24px;
  margin-top: -4px;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 18px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(25, 118, 210, 0.35);
}

.btn-primary:hover {
  filter: brightness(1.05);
}

.btn-ghost {
  width: 100%;
  padding: 10px;
  border: none;
  background: transparent;
  color: #9ca3af;
  font-size: 13px;
  cursor: pointer;
}

.btn-ghost:hover {
  color: #1976d2;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
